import { ArrowUpRight } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { Wordmark } from "@/components/brand/Logo";

const LINKS = [
  { to: "/restore", label: "Restore appeal" },
  { to: "/hipaa", label: "HIPAA" },
  { to: "/security", label: "Security" },
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
  { to: "/help", label: "Help" },
];

export function Footer() {
  // Starts at the build-time year so the prerendered HTML and the
  // browser's first render agree, then corrects itself after mount. A
  // page built in December and viewed in January would otherwise render
  // two different years on the two sides, which React reports as a
  // hydration failure rather than silently patching.
  const [year, setYear] = useState(__BUILD_YEAR__);

  useEffect(() => {
    const current = new Date().getFullYear();
    if (current !== year) setYear(current);
  }, [year]);

  return (
    <footer className="border-t border-line">
      <div className="mx-auto flex max-w-[1180px] flex-col gap-4 px-6 pb-[60px] pt-10 text-[12px] text-ink-muted sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <Wordmark size={22} textClassName="text-[16px]" />
        <ul className="flex flex-wrap gap-x-5 gap-y-2">
          {LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} className="transition-colors hover:text-ink">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
        <div>© {year} · HIPAA-aware · Not legal or medical advice</div>
      </div>
      <div className="border-t border-line">
        <div className="mx-auto flex max-w-[1180px] items-center justify-end px-6 py-3 text-[11px] text-ink-hint sm:px-8">
          <a
            href="https://www.caalm-ai.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 transition-colors hover:text-ink"
          >
            Powered by Caalm AI
            <ArrowUpRight size={11} strokeWidth={1.75} aria-hidden />
          </a>
        </div>
      </div>
    </footer>
  );
}
